import {
  Typography, Grid, Card, CardContent, CardMedia, Button,
  Chip, IconButton, Box, Avatar, Link
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StarIcon from "@mui/icons-material/Star";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";

import { dinero } from "../../utils/dinero";
import Carrusel from "../common/Carrusel";

const SectionService = ({
  services,
  title,
  subtitle,
  showAvailability = false,
  showPriece = false,
  favoriteService,
  irA,
  onVerDetalle,
}) => {
  return (
    <Box sx={{ position: "relative", mt: 4 }}>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid size={{ xs: 12, md: 6 }} sx={{ alignItems: "stretch" }}>
          <Typography variant="h6" color="primary">
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        </Grid>
      </Grid>

      <Carrusel etiquetas={['Servicios anteriores', 'Más servicios']}>
        {services.map((srv, index) => (
          <Card
            key={index}
            sx={{
              borderRadius: 3,
              boxShadow: 2,
              position: "relative",
              height: "100%",
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}
          >
            <CardMedia
              component="img"
              height="180"
              image={srv.image && srv.image !== ""
                ? srv.image
                : "/search.png"
              }
              alt={srv.title}
              onClick={() => onVerDetalle && onVerDetalle(srv)}
              sx={{ cursor: 'pointer' }}
            />
            {/* El degradado no debe interceptar el clic para que la foto lleve a detalles */}
            <Box className="transp" sx={{ height: 180, position: 'absolute', width: '100%', top: 0, left: 0, pointerEvents: 'none', background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)' }} />
            <IconButton
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: srv.favorite ? "primary.main" : "white",
                p: 0.5,
                bgcolor: srv.favorite ? "rgba(255,255,255,0.9)" : "transparent",
                '&:hover': { bgcolor: srv.favorite ? "white" : "rgba(255,255,255,0.2)" }
              }}
              onClick={() => favoriteService(srv)}
            >
              {srv.favorite
                ? <FavoriteIcon sx={{ fontSize: 20 }} />
                : <FavoriteBorderIcon sx={{ fontSize: 20 }} />
              }
            </IconButton>
            <Chip
              label={srv.category}
              color="primary"
              size="small"
              sx={{ position: "absolute", top: 10, left: 10, height: 20, fontSize: '0.65rem' }}
            />
            <Link
              component={RouterLink}
              to={`/perfil/${srv.autorId || srv.userId}`}
              underline="none"
              className="author_info"
              sx={{
                position: 'absolute',
                top: 140,
                left: 10,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                zIndex: 2,
                '&:hover': {
                  opacity: 0.8
                }
              }}
            >
              <Avatar
                alt={srv.author}
                src={srv.authorAvatar || "/broken-image.jpg"}
                sx={{ bgcolor: "primary", width: 30, height: 30, marginRight: 1 }}
              />
              <Typography variant="caption" fontWeight="bold" color="white">
                {srv.author}
              </Typography>
            </Link>
            <CardContent sx={{ p: 1.5, flexGrow: 1, display: 'flex', flexDirection: 'column', "&:last-child": { pb: 1.5 } }}>
              <Grid container spacing={1} sx={{ mb: 1 }}>
                <Grid size={{ xs: 9 }}>
                  <Typography variant="subtitle2" fontWeight="bold" color="primary" noWrap>
                    {srv.title}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 3 }} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                  {srv.rating && srv.rating !== "" &&
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <StarIcon sx={{ fontSize: 14, color: 'primary.main', mr: 0.2 }} />
                      <Typography variant="caption" fontWeight="bold">{srv.rating}</Typography>
                    </Box>
                  }
                </Grid>
              </Grid>

              <Typography variant="caption" color="text.secondary" sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                lineHeight: 1.2,
                mb: 1
              }}>
                {srv.description}
              </Typography>

              <Box sx={{ mb: 1 }}>
                <Typography variant="caption" fontWeight="bold" color="text.secondary" display="block">
                  {srv.author}
                </Typography>
                {srv.location && srv.location.trim() !== "" && (
                  <Box sx={{ display: "flex", alignItems: "center", mt: 0.2 }}>
                    <LocationOnIcon color="primary" sx={{ fontSize: 14, mr: 0.2 }} />
                    <Typography variant="caption" color="primary" noWrap>
                      {srv.location}
                    </Typography>
                  </Box>
                )}
                {srv.duration && /\d/.test(srv.duration) &&
                  <Box sx={{ display: "flex", alignItems: "center", mt: 0.2 }}>
                    <AccessTimeIcon sx={{ fontSize: 14, mr: 0.2, color: 'primary.main' }} />
                    <Typography variant="caption" color="primary">{srv.duration}</Typography>
                  </Box>
                }
              </Box>

              <Box sx={{ mt: 'auto', pt: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
                <Box>
                  {/* Cuántos servicios muestra la página (lo manda el servidor; uno sin actualizar no lo manda y no se dice nada) */}
                  {showAvailability && srv.serviciosDisponibles > 0 &&
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1 }}>
                      <strong>{srv.serviciosDisponibles}</strong> {srv.serviciosDisponibles === 1 ? 'servicio disponible' : 'servicios disponibles'}
                    </Typography>
                  }
                  {showPriece &&
                    <Box>
                      <Typography variant="subtitle1" color="primary" fontWeight="bold" sx={{ lineHeight: 1 }}>
                        {dinero(srv.price)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">por {srv.tipoCosto && srv.tipoCosto.toLowerCase()}</Typography>
                    </Box>
                  }
                </Box>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => onVerDetalle && onVerDetalle(srv)}
                  sx={{
                    px: 1,
                    py: 0.5,
                    fontSize: "0.75rem",
                    textTransform: "none",
                    borderRadius: 2,
                    minWidth: 'auto'
                  }}
                >
                  Ver detalle
                </Button>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Carrusel>
    </Box>
  );
};

SectionService.propTypes = {
  favoriteService: PropTypes.func.isRequired,
  irA: PropTypes.func.isRequired,
}

export default SectionService;
